import { render, staticRenderFns } from "./checkbox_group.vue?vue&type=template&id=16b584b8&scoped=true&"
import script from "./checkbox_group.vue?vue&type=script&lang=js&"
export * from "./checkbox_group.vue?vue&type=script&lang=js&"
import style0 from "./checkbox_group.vue?vue&type=style&index=0&id=16b584b8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b584b8",
  null
  
)

export default component.exports